function asRecord(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function isWalletCancel(reason) {
  const payload = asRecord(reason?.reason || reason);
  const status = String(
    payload.statusCode || payload.status || payload.code || payload.errorCode || ''
  ).toUpperCase();
  const message = String(payload.message || payload.error || payload.statusMessage || '').toLowerCase();
  return (
    status === 'CANCELED' ||
    status === 'CANCELLED' ||
    status === 'ABORT' ||
    status === 'ABORTED' ||
    message.includes('cancel') ||
    message.includes('closed')
  );
}

export function formatWalletError(reason) {
  if (isWalletCancel(reason)) return '';
  if (reason instanceof Error && reason.message) return reason.message;
  const payload = asRecord(reason);
  const message = payload.message || payload.error || payload.statusMessage;
  if (typeof message === 'string' && message.trim()) return message.trim();
  return '';
}
